
/**
 * 获取时间的相关操作
 */
//获取当前时间或者传参过来的时间，对此进行数据结构上的操作
export function dateFormat (type = 'yyyy-MM-dd', date = new Date()) {
  let time = new Date(date);
  let o = {
    "M+": time.getMonth() + 1,
    "d+": time.getDate(),
    "H+": time.getHours(),
    "m+": time.getMinutes(),
    "s+": time.getSeconds(),
    "q+": Math.floor((time.getMonth() + 3) / 3),
    "S": time.getMilliseconds()
  };
  if (/(y+)/.test(type)) {
    type = type.replace(RegExp.$1, (time.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(type)) {
      type = type.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return type;
}

// 导出名称日期处理
export const outTitle = (title,stime,etime) => {
  let str = `${title}(${stime}~${etime})`
  let time = str.replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '').replace(/\:/g, "-").replace(/\-/g, ".").replace(/\ /g, "-")
  return time;
};
/**
 * 日期加减(num为加减天数)
 */
export function getDay (aa) {
  let date = new Date();
  date.setDate(date.getDate() + aa);
  let time = date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + (date.getDate())).slice(-2);
  return time;
}
//处理时间格式，将2018-12-05 15:30:53.0 改为2018-12-05 15:30:53。
export const splitTime = (time) => {
  if (!time) {
    return time;
  }
  let timeArr = time.split(".");
  let newTime;
  if (timeArr.length > 0) {
    newTime = timeArr[0]
  }
  return newTime;
}
//将时间戳转换成日期
export const timestampToTime = (timestamp) => {
  var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = (date.getDate() + 1 < 10 ? '0' + (date.getDate() + 1) : date.getDate() + 1) + ' ';
  var h = date.getHours() + ':';
  var m = date.getMinutes() + ':';
  var s = date.getSeconds();
  return Y + M + D + h + m + s;
}
// 字符串只显示后两位其他显示为*号
export const interceptStr = (strVal) => {
  let str = '';
  for (let i in strVal) {
    if (i < strVal.length - 2) {
      str += '*'
    }
  }
  return str + strVal.substring(strVal.length - 2, strVal.length)
}

/*两个时间之间的验证数据验证*/
export const ValidataTime = (star, end, num, empty) => {
  let words = '';
  if (!empty) {
    if (!star) {
      words = `开始时间不能为空`;
      return words;
    }
    if (!end) {
      words = `结束时间不能为空`;
      return words;
    }
  } else {
    if (!star && end) {
      words = `开始时间不能为空`;
      return words;
    }
    if (!end && star) {
      words = `结束时间不能为空`;
      return words;
    }
  }
  if (new Date(star).getTime() > new Date(end).getTime()) {
    words = `结束时间不能小于开始时间`;
    return words;
  }
  let datas = ((new Date(end).getTime()) - new Date(star).getTime()) / (1000 * 60 * 60 * 24);

  if (num && datas > num) {
    words = `时间跨度最多${num == 365 || num == 366 ? '1年' : (num + '天')}`;
    return words;
  }
};

//求自然月日期
export const getMonthBeforeFormatAndDay = (num, format, day) => {
  var date = new Date();
  date.setMonth(date.getMonth() + (num * 1), 1);
  //读取日期自动会减一，所以要加一
  var mo = date.getMonth() + 1;
  //小月
  if (mo == 4 || mo == 6 || mo == 9 || mo == 11) {
    if (day > 30) {
      day = 30
    }
  }
  //2月
  else if (mo == 2) {
    if (isLeapYear(date.getFullYear())) {
      if (day > 29) {
        day = 29
      } else {
        day = 28
      }
    }
    if (day > 28) {
      day = 28
    }
  }
  //大月
  else {
    if (day > 31) {
      day = 31
    }
  }

  retureValue = date.format('yyyy' + format + 'MM' + format + day);

  return retureValue;
};

//JS判断闰年代码
export const isLeapYear = (Year) => {
  if (((Year % 4) == 0) && ((Year % 100) != 0) || ((Year % 400) == 0)) {
    return (true);
  } else { return (false); }
};
/***
 * 获得本周起止时间
 */
export const getCurrentWeek = () =>  {
  //起止日期数组
  var startStop = new Array();
  //获取当前时间
  var currentDate =  new Date();
  //返回date是一周中的某一天
  var week = currentDate.getDay();
  //返回date是一个月中的某一天
  var month = currentDate.getDate();

  //一天的毫秒数
  var millisecond = 1000 * 60 * 60 * 24;
  //减去的天数
  var minusDay = week != 0 ? week - 1 : 6;
  //alert(minusDay);
  //本周 周一
  var monday = new Date(currentDate.getTime() - (minusDay * millisecond));
  //本周 周日
  var sunday = new Date(monday.getTime() + (6 * millisecond));
  //添加本周时间
  startStop.push(dateFormat("yyyy-MM-dd",monday)); //本周起始时间
  //添加本周最后一天时间
  startStop.push(dateFormat("yyyy-MM-dd",sunday)); //本周终止时间
  //返回
  return startStop;
};
/***
 * 获得本月的起止时间
 */
export const getCurrentMonth = () => {
  //起止日期数组
  var startStop = new Array();
  //获取当前时间
  var currentDate =  new Date();
  //获得当前月份0-11
  var currentMonth = currentDate.getMonth();
  //获得当前年份4位年
  var currentYear = currentDate.getFullYear();
  //求出本月第一天
  var firstDay = new Date(currentYear, currentMonth, 1);


  //当为12月的时候年份需要加1
  //月份需要更新为0 也就是下一年的第一个月
  if (currentMonth == 11) {
    currentYear++;
    currentMonth = 0; //就为
  } else {
    //否则只是月份增加,以便求的下一月的第一天
    currentMonth++;
  }


  //一天的毫秒数
  var millisecond = 1000 * 60 * 60 * 24;
  //下月的第一天
  var nextMonthDayOne = new Date(currentYear, currentMonth, 1);
  //求出上月的最后一天
  var lastDay = new Date(nextMonthDayOne.getTime() - millisecond);

  //添加至数组中返回
  startStop.push(dateFormat("yyyy-MM-dd",firstDay));
  startStop.push(dateFormat("yyyy-MM-dd",lastDay));
  //返回
  return startStop;
};
/**
 * 得到本季度开始的月份
 * @param month 需要计算的月份
 ***/
export const getQuarterSeasonStartMonth = (month) => {
  var quarterMonthStart = 0;
  var spring = 0; //春
  var summer = 3; //夏
  var fall = 6;   //秋
  var winter = 9; //冬
  //月份从0-11
  if (month < 3) {
    return spring;
  }

  if (month < 6) {
    return summer;
  }

  if (month < 9) {
    return fall;
  }

  return winter;
};
/**
 * 获得该月的天数
 * @param year年份
 * @param month月份
 * */
export const getMonthDays = (year, month) => {
  //本月第一天 1-31
  var relativeDate = new Date(year, month, 1);
  //获得当前月份0-11
  var relativeMonth = relativeDate.getMonth();
  //获得当前年份4位年
  var relativeYear = relativeDate.getFullYear();

  //当为12月的时候年份需要加1
  //月份需要更新为0 也就是下一年的第一个月
  if (relativeMonth == 11) {
    relativeYear++;
    relativeMonth = 0;
  } else {
    //否则只是月份增加,以便求的下一月的第一天
    relativeMonth++;
  }
  //一天的毫秒数
  var millisecond = 1000 * 60 * 60 * 24;
  //下月的第一天
  var nextMonthDayOne = new Date(relativeYear, relativeMonth, 1);
  //返回得到上月的最后一天,也就是本月总天数
  return new Date(nextMonthDayOne.getTime() - millisecond).getDate();
};
/**
 * 获得本季度的起止日期
 */
export const getCurrentSeason = () => {
  //起止日期数组
  var startStop = new Array();
  //获取当前时间
  var currentDate =  new Date();
  //获得当前月份0-11
  var currentMonth = currentDate.getMonth();
  //获得当前年份4位年
  var currentYear = currentDate.getFullYear();
  //获得本季度开始月份
  var quarterSeasonStartMonth = this.getQuarterSeasonStartMonth(currentMonth);
  //获得本季度结束月份
  var quarterSeasonEndMonth = quarterSeasonStartMonth + 2;

  //获得本季度开始的日期
  var quarterSeasonStartDate = new Date(currentYear, quarterSeasonStartMonth, 1);
  //获得本季度结束的日期
  var quarterSeasonEndDate = new Date(currentYear, quarterSeasonEndMonth, this.getMonthDays(currentYear, quarterSeasonEndMonth));
  //加入数组返回
  startStop.push(dateFormat("yyyy-MM-dd",quarterSeasonStartDate));
  startStop.push(dateFormat("yyyy-MM-dd",quarterSeasonEndDate));
  //返回
  return startStop;
};
/***
 * 得到本年的起止日期
 *
 */
export const getCurrentYear = () => {
  //起止日期数组
  var startStop = new Array();
  //获取当前时间
  var currentDate =  new Date();
  //获得当前年份4位年
  var currentYear = currentDate.getFullYear();

  //本年第一天
  var currentYearFirstDate = new Date(currentYear, 0, 1);
  //本年最后一天
  var currentYearLastDate = new Date(currentYear, 11, 31);
  //添加至数组
  startStop.push(dateFormat("yyyy-MM-dd",currentYearFirstDate));
  startStop.push(dateFormat("yyyy-MM-dd",currentYearLastDate));
  //返回
  return startStop;
}


export const weekData = (type) => {    //获取本周日期
  const now = new Date();
  
  if (type == 'month') {   //月初~月末
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth();
    //求出本月第一天
    const firstDay = new Date(currentYear, currentMonth, 1);
    //求出下个月第一天
    const nextMonthDayOne = new Date(currentYear, currentMonth + 1, 1);
    //一天的毫秒数
    const millisecond = 1000 * 60 * 60 * 24;
    //求出本月最后一天
    const lastDay = new Date(nextMonthDayOne.getTime() - millisecond);
    
    return {
      begin: dateFormat("yyyy-MM-dd", firstDay),
      end: dateFormat("yyyy-MM-dd", lastDay)
    }
  } else if (type == 'now') {  //月初 ~今天
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth();
    //求出本月第一天
    const firstDay = new Date(currentYear, currentMonth, 1);
    
    return {
      begin: dateFormat("yyyy-MM-dd", firstDay),
      end: dateFormat("yyyy-MM-dd", now)
    }
  } else {   //本周一~本周末
    const date = new Date(now);
    // 本周一的日期
    date.setDate(date.getDate() - date.getDay() + 1);
    const begin = dateFormat("yyyy-MM-dd", date);
    // 本周日的日期
    date.setDate(date.getDate() + 6);
    const end = dateFormat("yyyy-MM-dd", date);
    
    return {
      begin: begin,
      end: end
    }
  }
};

/**
 * 递归操作树结构
 */
//递归 - 删除公司树中nlist为空的数组
export const handTreeList = (arr, childname, names) => {
  let childn = childname ? childname : 'childList'
  for (let i in arr) {
    let item = arr[i];
    if (names) {      //重构唯一标识
      item.myid = '';
      for (let j in names) {
        let childitem = names[j];
        let str = j == names.length - 1 ? '' : '+'
        if (item[childitem]) item.myid += item[childitem] + str;
      }
    }
    if (item[childn] && item[childn].length === 0) {
      delete item[childn]
    } else {
      handTreeList(item[childn], childn, names)
    }
  }
};
//递归 - 修改公司树数据
export const modifyTree = (arr) => {
  for (let i in arr) {
    if (arr[i].status === 2) arr[i].ndname = arr[i].ndname + '【禁用】';
    //if (arr[i].type === 1) arr[i].ndname = arr[i].ndname + '【公司】';
    //if (arr[i].type === 2) arr[i].ndname = arr[i].ndname + '【区域】';
    //if (arr[i].type === 3) arr[i].ndname = arr[i].ndname + '【子公司】';
    if (arr[i].nlist) {
      modifyTree(arr[i].nlist);
    }
  }
};
//递归 - 修改公司树数据
export const disableTree = (tree, type) => {/* 1-添加文字禁用，2-实体禁用，3-两者都要*/
  for (let i in arr) {
    if (tree[i].status === 2) {  /* 新增一个type的参数，用来够着禁用数据*/
      if (type && type === 1) {
        tree[i].ndname = tree[i].ndname + '【禁用】'
      } else if (type && type === 2) {
        tree[i].ndname = tree[i].ndname + '【禁用】';
        tree[i].disabled = true;
      } else {
        tree[i].disabled = true;
      }
    }
    if (tree[i].nlist) {
      modifyTree(tree[i].nlist, type);
    }
  }
};
//递归 - 重新构建上级区域选项
export const areaTree = (arr, id, type) => {
  for (let i in arr) {
    if (arr[i].ndid === id && arr[i].type === parseInt(type)) {
      delete arr[i];
    } else {
      if (arr[i].nlist) {
        areaTree(arr[i].nlist, id, type);
      }
    }

  }
};
//递归 - 变更区域级联菜单构建
export const getTreeList = (arr, value, list) => {
  if (list === undefined) {
    let list = {};
  }
  for (let i in arr) {
    if (value === arr[i].id) {
      return list = arr[i];
    } else {
      if (arr[i].nlist) {
        let findRelut = getTreeList(arr[i].nlist, value, list);
        if (findRelut) return findRelut;
      }
    }
  }
};
//递归 - 丛叶子节点找到以上父节点
export const findPathByLeafId = (leafId, type, nodes, path) => {
  if (path === undefined) {
    path = [];
  }
  for (let i = 0; i < nodes.length; i++) {
    let tmpPath = path.concat();
    tmpPath.push(nodes[i].ndid);
    if (leafId === nodes[i].ndid && parseInt(type) === nodes[i].type) {
      return tmpPath;
    }
    if (nodes[i].nlist) {
      let findResult = findPathByLeafId(leafId, type, nodes[i].nlist, tmpPath);
      if (findResult) {
        return findResult;
      }
    }
  }
};
/*
 * 递归 - 构建数据
 * leafId - 根节点
 * keyname - 关键值的名称
 * childname - 子菜单名称
 * nodes - 数组
 * path - 路径
 * */
export const findPathByLeafId1 = (leafId, keyname, childname, nodes, path) => {
  if (path === undefined) {
    path = [];
  }
  for (let i = 0; i < nodes.length; i++) {
    let tmpPath = path.concat();
    tmpPath.push(nodes[i][keyname]);
    if (leafId === nodes[i][keyname]) {
      return tmpPath;
    }
    if (nodes[i][childname]) {
      let findResult = findPathByLeafId1(leafId, keyname, childname, nodes[i][childname], tmpPath);
      if (findResult) {
        return findResult;
      }
    }
  }
};



/**
 * 获取上传文件名字操作
 */
//上传的位置显示文件名
export const fileList = (val) => {
  let arr = []
  for (let i in val) {
    let files = {}
    files.url = val[i];
    files.name = filesName(val[i])
    arr.push(files)
  }
  return arr
};
//得到上传文件的文件名
export const filesName = (url) => {
  let nameArr = url.split('/')
  return nameArr[nameArr.length - 1]
};



/**
 * 其他相关操作
 */
//价格换算
export const formasales = (num) => {
  let returnPrice = 0;
  if (num) {
    returnPrice = Number((num / 100).toFixed(2));
  }
  return returnPrice;
};
export const formaprice = (num) => {
  let returnPrice = 0;
  if (num) {
    returnPrice = (num / 100).toLocaleString();
  }
  return returnPrice;
};

//导出价格只除以100 不用toLocaleString转换
export const formaOutSales = (num) => {
  let returnPrice = 0;
  if (num) {
    returnPrice = Number((num / 100).toFixed(2))
  }
  return returnPrice;
};

//禁止返回按钮
export const noBack = () => {
  history.pushState(null, null, document.URL);
  window.addEventListener('popstate', function () {
    history.pushState(null, null, document.URL);
  });
};

//号码中间隐藏 例如:手机136****1111
export const $hidePhone = (val, start, end) => {
  let startnum = start ? start : 4
  let endnum = end ? end : -4
  return val.substr(0, startnum) + "********" + val.substr(endnum);
};

// 树形结构转平行父子结构
export const nodes2Array = (nodes) => {
  if (!nodes) return [];
  var childKey = "children",
    r = [];
  if (nodes instanceof Array) {
    for (var i = 0, l = nodes.length; i < l; i++) {
      r.push(nodes[i]);
      if (nodes[i][childKey])
        r = r.concat(nodes2Array(nodes[i][childKey]));
    }
  } else {
    r.push(nodes);
    if (nodes[childKey])
      r = r.concat(nodes2Array(nodes[childKey]));
  }
  return r;
}



// WEBPACK FOOTER //
// ./src/config/mUtils.js